import { create } from 'zustand';

import { SchoolSettingsRepository } from '../../api/repository/school-settings';
import type { QltSchoolSettings } from '../../api/types';
import { userError } from '../userError';
import { type MaybeMsg } from '../../i18n/msg.ts';

export interface QltSchoolSettingsState {
  settings: QltSchoolSettings | null;
  loading: boolean;
  error: MaybeMsg | null;
  load: () => Promise<QltSchoolSettings | null>;
}

export const useQltSchoolSettingsStore = create<QltSchoolSettingsState>((set) => ({
  settings: null,
  loading: false,
  error: null,
  async load() {
    set({ loading: true, error: null });
    try {
      const settings = await SchoolSettingsRepository.fetch();
      set({ settings, loading: false });
      return settings;
    } catch (error) {
      set({ loading: false, error: userError(error) });
      return null;
    }
  },
}));
